export default class Reveal {
    private readonly overlay: HTMLElement;
    private readonly target: HTMLElement;

    constructor(overlay: HTMLElement, target: HTMLElement) {
        this.overlay = overlay;
        this.target = target;

        this.reveal = this.reveal.bind(this);

        overlay.querySelectorAll('button').forEach(button => {
            button.addEventListener('click', this.reveal);
        });

        this.hide();
    }

    reveal() {
        this.target.setAttribute('data-hidden', 'false');
        this.overlay.hidden = true;
    }

    hide() {
        this.target.setAttribute('data-hidden', 'true');
        this.overlay.hidden = false;
    }

    static createFromSelector(selector: string) {
        return Array.from(document.querySelectorAll<HTMLElement>(selector)).map(container => {
            const targetId = container.getAttribute('data-target');

            if (!targetId) {
                throw new Error('Reveal overlay component requires a "data-target" attribute.');
            }

            const target = document.getElementById(targetId);

            if (target === null) {
                throw new Error(`Reveal target id "${targetId}" does not refer to a valid element.`);
            }

            return new Reveal(container, target);
        });
    }
}
